var exports = {
  "Y3": "ComposerHolidayPeek.module__anchor___anR2Mm",
  "M6": "ComposerHolidayPeek.module__slide___anR2Mm",
  "bj": "ComposerHolidayPeek.module__composer-holiday-peek-in___anR2Mm",
  "Sj": "ComposerHolidayPeek.module__composer-holiday-peek-out___anR2Mm",
  "dw": "ComposerHolidayPeek.module__stage___anR2Mm",
  "aM": "ComposerHolidayPeek.module__noHalo___anR2Mm",
};

module.exports = exports;
